import React from "react";
import Auth from "./Auth";
import Candidate from "./Candidate";
import Insider from "./Insider";

export default () => (
  <React.Fragment>
    <Auth />
    <Candidate />
    <Insider />
  </React.Fragment>
);



// WEBPACK FOOTER //
// ./src/components/pages/index.js